import React from 'react';
import * as PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Badge } from '@material-ui/core';
import { selectListTotal } from '../../../lists/selectors';
import { useResourceList } from '../../../lists/hooks';
import { useBadgeRefresh } from './useBadgeRefresh';
import { CUSTOMER_RESOURCE } from '../../../api/resources';

const LeadBadge = ({ children }) => {
    const listId = 'customer.prospectiveFilter';

    const { handlePage: handleCustomerUpdate } = useResourceList({
        listId,
        resource: CUSTOMER_RESOURCE,
        staticParams: {
            currentType: 'prospective',
            employeeId: 'null',
        },
        limit: 1,
        autoload: false,
        continuous: true,
        refresh: true,
    });

    const count = useSelector((state) => selectListTotal(state, listId));

    useBadgeRefresh(handleCustomerUpdate, CUSTOMER_RESOURCE);

    return (
        <Badge badgeContent={count} color="primary" key={`leadbadge.${listId}`}>
            {children}
        </Badge>
    );
};

LeadBadge.propTypes = {
    children: PropTypes.node.isRequired,
};

LeadBadge.defaultProps = {};

export default LeadBadge;
